import { IUpdateProcessoRiscosUseCase } from "../../../presentation/useCases/update/updade_processo_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateProcessoRiscosUseCase


export class UpdateProcessoRiscosUseCase implements IUpdateProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateProcessoRiscos(IdProcesso: number, Ano: string): Promise<void> {
    
    await this.repository.updateProcessoRiscos(IdProcesso, Ano );
  }
}
